import { useCallback } from 'react';
import { notification } from 'components';
import { ErrorMappingValueType } from 'typings';
import { useSupplierOnlineShopDeleteMutation } from 'api';

export const useDeleteModal = (onDeleteModalClose: () => void) => {
  const [notificationApi, contextHolder] = notification.useNotification();
  const [onlineShopDelete, { isLoading }] = useSupplierOnlineShopDeleteMutation();
  const openNotificationWithIcon = useCallback(
    (messageContent: ErrorMappingValueType) => {
      const { type, message } = messageContent;
      notificationApi[type]({ message: message });
    },
    [notificationApi]
  );

  const onRemoveConfirm = useCallback(
    async (dataToDelete: { id: string }) => {
      try {
        const { data, error }: any = await onlineShopDelete({
          onlineShopId: dataToDelete.id,
        });
        if (data?.success) {
          openNotificationWithIcon({
            type: 'success',
            message: `The Online Shop was successfully deleted.`,
          });
          onDeleteModalClose();
        } else if (error?.data?.success === false) {
          const { data = {} } = error.data;
          Object.keys(data).forEach((_key: string) => {
            openNotificationWithIcon({
              type: 'error',
              message: data[_key],
            });
          });
        } else {
          openNotificationWithIcon({
            type: 'error',
            message: error?.data?.error || 'Something went wrong!',
          });
        }
      } catch (err) {
        console.error('Error deleting Online Shop:', err);
        openNotificationWithIcon({
          type: 'error',
          message: 'An unexpected error occurred!',
        });
      }
    },
    [onlineShopDelete, openNotificationWithIcon, onDeleteModalClose]
  );

  return {
    onRemoveConfirm,
    contextHolder,
    isLoading,
  };
};
